import { useNavigate } from "react-router-dom";
import { useLimitData, usePlanData, useSdaToken } from "./api";
import useProfileData from "hooks/useProfileData";
import LimitSwiperCard from "./components/LimitSwiperCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { useEffect, useState } from "react";
import Button from "features/newLanding/Button/Button";
import { sendMessage } from "./config";
import Modal from "components/modals/TestModal";
import WarningIcon from "assets/icons/WarningIcon";
import AccountTypeModal from "./components/AccountTypeModal";
import { useIntercom } from "react-use-intercom";

export const messages = {
  upgrade: "Hello, I want to activate the premium plan",
  downgrade: "Hello, I want to change my plan",
};

const LimitsPage = () => {
  const navigate = useNavigate();
  const { show, update, boot } = useIntercom();
  const [warningOpen, setWarningOpen] = useState(false);
  const [typeModalOpen, setTypeModalOpen] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [sdaPage, setSdaPage] = useState(false);
  const { data: limitData } = useLimitData();
  const { profile = {} } = useProfileData();
  const { data: planData } = usePlanData();
  const { data: sda, mutate: refetchSdaToken } = useSdaToken(
    accountType === "INDIVIDUAL"
  );

  const [currentSlide, setCurrentSlide] = useState(0);
  const planArr = Object.entries(planData || {})
    .filter(([, value]) => value != null)
    .map(([key, value]) => ({ key, value }));

  useEffect(() => {
    boot({
      hideDefaultLauncher: true,
      hide_default_launcher: true,
    });
  }, [boot]);
  useEffect(() => {
    const handleMessage = (event) => {
      // Step 1: Validate message origin
      if (event.origin !== "https://widget.identomat.com") return;
      console.log("1 : EVENT DATA", event.data);

      // Step 2: Validate message content
      if (event.data !== "DONE") return;
      console.log("2 : EVENT DATA", event.data);
      // Step 3: Handle the message (same logic as onMessage in React Native)
      console.log("VERIFICATION_DONE received");

      // Example: navigate or update app state
      navigate("/identomat-finalize", {
        state: { kycSessionToken: sda?.token },
      });
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate, sda]);

  const handleOpenWhatsUpp = () => {
    const warningCondition =
      profile?.userType === "BUSINESS" && !profile?.isMaster;

    if (profile?.userType === "INDIVIDUAL" && !profile?.verified) {
      setTypeModalOpen(true);
    }
    if (warningCondition) {
      setWarningOpen(true);
    }
    if (profile?.verified && !warningCondition) {
      console.log(123);
      sendMessage(messages?.downgrade, show, update);
    }
  };
  const handleCloseWarning = () => {
    setWarningOpen(false);
    // refetchSdaToken(undefined, { revalidate: true });
  };

  const handleContinue = () => {
    if (accountType === "INDIVIDUAL" && profile?.countryCode === "995") {
      setTypeModalOpen(false);
      setSdaPage(true);
    } else {
      sendMessage(messages?.upgrade);
    }
  };

  const handleClearToken = () => {
    setWarningOpen(true);
  };

  return (
    <>
      {sdaPage && sda?.token ? (
        <div className="h-full">
          <div className="p-3">
            <img
              src="/svg/leftArrow.svg"
              alt="left"
              className="cursor-pointer pl-5"
              onClick={handleClearToken}
            />
          </div>
          <iframe
            src={`https://widget.identomat.com/?session_token=${sda?.token}`}
            title="Embedded Content"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            allow="camera; microphone"
          />
        </div>
      ) : (
        <div className="h-full overflow-auto flex flex-col sm2:w-[600px]  justify-between  mx-auto no-scrollbar ">
          <div>
            <div className="divide-y-[1px] divide-y-reverse  border-[#efeff0] mb-5 ">
              <div className="w-full relative flex mx-auto  items-center py-3   ">
                <img
                  src="/svg/leftArrow.svg"
                  alt="left"
                  className="cursor-pointer pl-5"
                  onClick={() => navigate(-1)}
                />
                <p className=" absolute left-1/2 transform -translate-x-1/2 font-bold   text-lg ">
                  Service plans
                </p>
              </div>
              <div className="divide-y-[1px] divide-y-reverse  border-[#efeff0]"></div>
            </div>

            <Swiper
              pagination={{
                el: "#my-custom-pagination-div2",
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + "</span>";
                },
              }}
              modules={[Pagination]}
              onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
              slidesPerView={1}
              spaceBetween={20}
            >
              {planArr && planArr?.length > 1 && (
                <SwiperSlide style={{ width: "100%" }}>
                  <LimitSwiperCard
                    planData={planData}
                    limitData={limitData}
                    profile={profile}
                    checkAll={false}
                  />
                </SwiperSlide>
              )}

              <SwiperSlide style={{ width: "100%" }}>
                <LimitSwiperCard
                  planData={planData}
                  limitData={limitData}
                  profile={profile}
                  header={"Business"}
                  colors={{
                    border: "#6C63FF",
                    bg: "#f8f7ff",
                    bgDark: "#f1f0ff",
                  }}
                />
              </SwiperSlide>
            </Swiper>

            <div
              className="flex gap-[10px] justify-center mt-[40px] "
              id="my-custom-pagination-div2"
            />
          </div>
          <div className="flex justify-center mb-5 mx-5   mt-5">
            {planArr?.length > 1 && currentSlide === 0 && (
              <Button
                className=" bg-[#e8e6eb] w-full py-3 text-[#807791] text-xl"
                disabled={true}
              >
                Your current plan
              </Button>
            )}
            {(planArr.length === 1 || currentSlide === 1) && (
              <Button
                className="bg-primary-main text-white w-full py-3 text-xl "
                onClick={handleOpenWhatsUpp}
              >
                {planArr?.length > 1 && !profile?.verified
                  ? "Upgrade"
                  : "Change the plan"}
              </Button>
            )}
          </div>

          <AccountTypeModal
            open={typeModalOpen}
            setOpen={setTypeModalOpen}
            setType={setAccountType}
            type={accountType}
            onClick={handleContinue}
            token={sda?.token}
          />
        </div>
      )}
      <Modal
        show={warningOpen && !sdaPage}
        onClose={handleCloseWarning}
        isEcomm={true}
        width="300px"
      >
        <div className="flex flex-col gap-5 items-center pb-3 px-3">
          <div className="flex flex-col items-center gap-[5px] font-bold">
            <WarningIcon />
            <p className="text-sm text-center">
              Only the administrator can change the plan.
            </p>
          </div>

          <Button
            className="text-[#007AFF] font-bold "
            onClick={handleCloseWarning}
          >
            OK
          </Button>
        </div>
      </Modal>
      <Modal
        show={sdaPage && warningOpen}
        onClose={handleCloseWarning}
        isEcomm={true}
        width="300px"
      >
        <div className="flex flex-col gap-5 items-center pb-3 px-3">
          <div className="flex flex-col items-center gap-[5px] font-bold">
            <WarningIcon />
            <p className="text-sm text-center">
              Are you sure you want to go back?
            </p>

            <p className="text-center text-xs font-normal">
              Verification process will be cancelled.
            </p>
          </div>

          <div className="flex w-full justify-center gap-36">
            <Button
              className="text-[#007AFF]"
              onClick={() => {
                setSdaPage(false);
                setWarningOpen(false);
                setAccountType(null);
              }}
            >
              Yes
            </Button>
            <Button
              className="text-[#007AFF] font-bold"
              onClick={() => setWarningOpen(false)}
            >
              No
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LimitsPage;
